import { SelectedFile } from '../components/forms/FileUpload';

/**
 * Web platform does not support camera/photo library access through these APIs
 * Camera functionality is handled by FileUpload component's native file input
 */

export const requestCameraPermission = async (): Promise<boolean> => {
  console.warn('Camera permission not applicable on web platform');
  return false;
};

export const requestMicrophonePermission = async (): Promise<boolean> => {
  console.warn('Microphone permission not applicable on web platform');
  return false;
};

export const requestPhotoLibraryPermission = async (): Promise<boolean> => {
  console.warn('Photo library permission not applicable on web platform');
  return false;
};

export const takePhoto = async (): Promise<SelectedFile | null> => {
  console.warn('Camera capture not supported on web platform');
  return null;
};

export const recordVideo = async (): Promise<SelectedFile | null> => {
  console.warn('Video recording not supported on web platform');
  return null;
};

export const chooseFromLibrary = async (
  _mediaType: 'photo' | 'video' | 'mixed' = 'mixed',
  _selectionLimit: number = 0
): Promise<SelectedFile[]> => {
  console.warn('Photo library picker not supported on web platform');
  return [];
};

export const cameraService = {
  takePhoto,
  recordVideo,
  chooseFromLibrary,
  requestCameraPermission,
  requestMicrophonePermission,
  requestPhotoLibraryPermission,
};
